export default __webpack_public_path__ + "static/media/calendar.92039832.svg";